import {useStores} from '../stores/useStores';

import {Helmet} from "react-helmet-async";

import { observer } from "mobx-react-lite";
import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import * as identityImg from "identity-img";
import { ClefDisc, play_song_by_asset_id, stop, get_song_name_by_asset_id} from 'clef-ui-sdk';

import axios from 'axios';

import {verifiedCollections} from '../constants/common';

import Zoom from 'react-medium-image-zoom';
import Skeleton from 'react-loading-skeleton';

import "./NftPage/styles.css";
import CardStore from 'src/stores/CardStore';

import PriceBlock from './NftPage/PriceBlock';
import Auction, {IBidParams} from './Auction';
import Tabs from './Tabs';
import SizedBox from './SizedBox';
import { getVoteById, IResultById } from './DaoPage/Data';

import {ReactComponent as VerifiedIcon} from '../assets/icons/verified.svg';
import {ReactComponent as DownloadIcon} from '../assets/icons/download.svg';
import {ReactComponent as LikeIcon} from '../assets/icons/like_m.svg';
import {ReactComponent as UnLikeIcon} from '../assets/icons/unlike_m.svg';

enum TABS {
    PRICE='price',
    AUCTION='auction'
}

interface INftPageProps {
    auction?: boolean;
    burn?: boolean;
}

export default observer(function(props: INftPageProps) {
    const { walletStore } = useStores();
    let { nftId, burn } = useParams();

    const [nftData, setNftData] = useState<CardStore|null>(null);
    const [version, setVersion] = useState<number>(1);

    const [preloadBids, setPreloadBids] = useState<IBidParams[]>([]);
    const [bidsCount, setBidsCount] = useState<number>(0);

    const [isAudio, setIsAudio] = useState<boolean|null>(null);
    const [isVideo, setIsVideo] = useState<boolean|null>(null);

    const [activeTab, setActiveTab] = useState<string>(props.auction ? TABS.AUCTION : TABS.PRICE);

    const [imageLoader, setImageLoader] = useState<HTMLImageElement|null>(new Image());
    const [imageSrc, setImageSrc] = useState<string>('');

    const [characteristics, setCharacteristics] = useState<any[]>([]);

    const [isPlay, setIsPlay] = useState<boolean>(false);
    const [playLoading, setPlayLoading] = useState<boolean>(false);

    const [clefName, setClefName] = useState<string>();

    const [voteData, setVoteData] = useState<IResultById|null>();

    const isClef = nftData?.creator === '3P4m4beJ6p1pMPHqCQMAXEdquUuXJz72CMe';

    useEffect(() => {
        walletStore.loadNftData(nftId as string, true).then((data) => {
            setNftData(data);
            if (data?.imageUrl) {
                if (['wavesducks', 'waveslands', 'waves.domains'].some((w) => data.imageUrl.indexOf(w) >= 0)) {
                    setImageSrc(data.imageUrl);
                } else {
                    axios.get(data?.imageUrl).then((response) => {
                        if (response.headers?.['content-type'].indexOf('audio') >= 0) {
                            setIsAudio(true);
                        } else if (response.headers?.['content-type'] !== 'video/mp4') {
                            if (imageLoader && !imageLoader.src) {
                                imageLoader.src = data.imageUrl;
                                imageLoader.onload = () => {
                                    setImageSrc(data.imageUrl);
                                };
                            }
                            setIsVideo(false);
                        } else {
                            setIsVideo(true);
                        }
                    });
                }
            }
            if (data?.assetId) {
                walletStore.loadAuction(data.assetId).then((data) => {
                    setPreloadBids(data);
                    setBidsCount(data.length);
                })
            }
        });
        return () => {
            setVersion(0);
            if (imageLoader?.onload) {
                imageLoader.onload = null;
            }
            setImageLoader(null);
        }
    }, [version]);

    useEffect(() => {
        if (nftData?.collectionId) {
            getVoteById(nftData.collectionId).then((result) => {
                setVoteData(result);
            });
        }
    }, [nftData]);

    useEffect(() => {
        if (nftData?.assetId && isClef) {
            get_song_name_by_asset_id(nftData?.assetId, {}).then((name) => {
                setClefName(name);
            })
        }
    }, [nftData]);

    let ownerAddressImage = '';
    let ownerAddress = '';
    let creatorAddressImage = '';
    let creatorAddress = '';
    
    if (nftData?.creator) {
        creatorAddressImage = identityImg.create(nftData.creator, {size: 40});

        creatorAddress = nftData.creator ?
            nftData.creator.substring(3, 0) + '...' + nftData.creator.substring(nftData.creator.length - 3) :
            '';
    }
    if (nftData?.seller) {
        ownerAddressImage = identityImg.create(nftData.seller, {size: 40});

        ownerAddress = nftData.seller ?
            nftData.seller.substring(3, 0) + '...' + nftData.seller.substring(nftData.seller.length - 3) :
            '';
    }

    const whiteListVerify = nftData && verifiedCollections.indexOf(nftData.collectionId) >= 0;

    const tabs = [{
        id: TABS.PRICE,
        title: 'Buyout price',
        active: activeTab === TABS.PRICE,
        onClick: (id: string) => {setActiveTab(id as TABS)}
    }, {
        id: TABS.AUCTION,
        title: 'Offers',
        count: bidsCount,
        active: activeTab === TABS.AUCTION,
        onClick: (id: string) => {setActiveTab(id as TABS)}
    }];

    return (
        <div className='nftMarketplace-card'>
            <Helmet>
                <title>Puzzle NFT Market - {nftData?.name || ''}</title>
                <meta name="description" content={nftData?.description || ''} />
                <meta property="og:title" content={nftData?.name ? 'Puzzle NFT Market - ' + nftData?.name : ''} />
                <meta property="og:image" content={!isVideo ? imageSrc : ''} />
            </Helmet>
            {
                isClef ?
                    <div className='nftMarketplace-card__imageBlock' title={isPlay ? 'stop' : 'play'}>
                        <div className='nftMarketplace-card__clef' onClick={async () => {
                            if (!isPlay) {
                                setPlayLoading(true);
                                await play_song_by_asset_id(nftData.assetId, async () => {
                                    setIsPlay(!isPlay);
                                    setPlayLoading(false);
                                }, {});
                                setIsPlay(false);
                            } else {
                                await stop();
                                setIsPlay(false);
                            }
                        }}>
                            <ClefDisc assetID={nftData.assetId} isAnimate={isPlay} />
                            {playLoading ? <div className='nftMarketplace-card__clefLoading'>Loading...</div> : ''}
                        </div>
                    </div> :
                    <div className='nftMarketplace-card__imageBlock'>
                        {
                            !isVideo && !isAudio && imageSrc ?
                                <Zoom overlayBgColorStart='rgba(0, 0, 0, 0)' wrapStyle={{width: '100%'}} overlayBgColorEnd='rgba(0, 0, 0, 0.8)'>
                                    <div className='nftMarketplace-card__imageWrap' style={{backgroundColor: nftData?.bgColor}}>
                                        <img className='nftMarketplace-card__image' src={imageSrc} alt="" />
                                        { nftData?.achievements?.length ?
                                            <div className='nftMarketplace-card__achievements'>
                                                { nftData.achievements.map((item) => {
                                                    return <img key={item} title={item} src={`https://wavesducks.com/ducks/achievements/${item}.png`} />
                                                }) }
                                            </div>
                                            : ''}
                                    </div>
                                </Zoom> :
                                isVideo && nftData?.imageUrl ?
                                    //<Zoom wrapStyle={{width: '100%'}} overlayBgColorStart='rgba(0, 0, 0, 0)' overlayBgColorEnd='rgba(0, 0, 0, 0.8)'>
                                        <video className='nftMarketplace-card__video' autoPlay muted loop controls>
                                            <source src={nftData.imageUrl} type="video/mp4" />
                                        </video> :
                                    //</Zoom> :
                                    isAudio && nftData?.imageUrl ? 
                                        <audio src={nftData.imageUrl} controls></audio> :
                                        <Skeleton baseColor="#c6c9f4" height={200} borderRadius={12}/>
                        }
                    </div>
            }
            <div className='nftMarketplace-card__info'>
                <div className='nftMarketplace-card__title'>
                    {nftData?.name && nftData?.isDuck ? nftData.name.replace(/\s[0-9]+%/, "") : clefName || nftData?.name || <Skeleton width={150}/>}{nftData?.quantity === 0 ? ' - NFT is not found' : '' }
                </div>
                <div className='nftMarketplace-card__collectionWrap'>
                    {
                        nftData?.hasCollectionUrl ? <Link className='nftMarketplace-card__collectionLink' to={nftData.collectionUrl}>{nftData.collectionName}</Link> : ''
                    }
                    {
                        whiteListVerify || voteData?.confirmed ?
                            <VerifiedIcon className='nftMarketplace-card__nameVerified' title='Verified' /> : ''
                    }
                </div>
                <div className="nftMarketplace-card__toolsBlock">
                    {
                        nftData?.isAllowLikes ?
                            <div className="nftMarketplace-card__likeBlock">
                                {
                                    nftData.isUserLiked ? <UnLikeIcon /> : <LikeIcon onClick={() => { nftData.like(() => setVersion(version+1)) }}/>
                                }
                                {nftData.likeCount ? <div className="nftMarketplace-card__likeCount">{nftData.likeCount}</div> : ''}
                            </div> : ''
                    }
                    {
                        nftData?.originalUrl ?
                            <a href={nftData.originalUrl} download target="_blank" className="nftMarketplace-card__likeBlock"><DownloadIcon/></a> : ''
                    }
                    {
                        nftData && nftData?.quantity && !nftData.seller && props.burn ?
                            <button
                                className='nftMarketplace-card__button nftMarketplace-card__button_red'
                                style={{marginLeft: '5px'}}
                                onClick={() => { nftData.burn(() => {setVersion(version + 1)}) }}>Burn</button> : ''
                    }
                </div>
                <div className='nftMarketplace-card__addresses'>
                    <div className='nftMarketplace-card__address'>
                        {
                            ownerAddressImage ?
                                <img className='nftMarketplace-card__addressImage' src={ownerAddressImage} alt="" /> :
                                ''
                        }
                        
                        <div className='nftMarketplace-card__addressInfo'>
                            { ownerAddress ? <div>Owner</div> : ''}
                            {
                                ownerAddress ?
                                    <Link className='nftMarketplace-card__addressLink' to={`/address/${nftData?.seller}`}>{ownerAddress}</Link> :
                                    ''
                            }
                            
                            {/* <a
                                className='nftMarketplace-card__addressLink'
                                target="_blank"
                                href={`https://wavesexplorer.com/address/${nftData?.seller}/tx`}></a> */}
                        </div>
                    </div>
                    {
                        ownerAddress ? <div className='nftMarketplace-card__addressSeparator'></div> : ''
                    }
                    <div className='nftMarketplace-card__address'>
                        {
                            !nftData ?
                                <Skeleton circle={true} width={40} height={40} /> :
                                creatorAddressImage ?
                                    <div className='nftMarketplace-card__addressImageWrap'>
                                        <img className='nftMarketplace-card__addressImage' src={creatorAddressImage} alt="" />
                                    </div>
                                    
                                    : ''
                                
                        }
                        {
                            !nftData ?
                                <div className='nftMarketplace-card__addressInfo'>
                                    <div><Skeleton width={70}/></div>
                                    <Skeleton />
                                </div> :
                                    creatorAddress ?
                                    <div className='nftMarketplace-card__addressInfo'>
                                        <div>Creator</div>
                                        <a
                                            className='nftMarketplace-card__addressLink'
                                            target="_blank"
                                            href={`https://wavesexplorer.com/address/${nftData?.creator}/tx`}>{creatorAddress}</a>
                                    </div> : ''
                        }
                        
                    </div>
                </div>

                {
                    nftData?.quantity === 0 ? 
                        <div className='nftMarketplace-card__notFound'>NFT not found or has already been sold or burned</div> :
                        ''
                }

                {
                    !nftData ? 
                        <div className='nftMarketplace-card__description'>
                            <div className='nftMarketplace-card__descriptionTitle'><Skeleton width={100}/></div>
                            <div><Skeleton count={2}/></div>
                        </div> : 
                        (
                            nftData.description ?
                                <div className='nftMarketplace-card__description'>
                                    <div className='nftMarketplace-card__descriptionTitle'>Description</div>
                                    <div>{nftData.description.split("\n").map((item, index) => <div key={index}>{item}</div>)}</div>
                                </div> : ''
                        )
                }

                {
                    nftData?.characteristics.length ?
                        <div className='nftMarketplace-card__description'>
                            <div className='nftMarketplace-card__descriptionTitle'>Characteristics</div>
                            <div className='nftMarketplace-card__params'>
                                {nftData.characteristics.map((item) => {
                                    return <div className='nftMarketplace-card__paramsRow' key={item.id}>
                                        <div className='nftMarketplace-card__paramsTitle'>{item.title}:</div>
                                        <div className={'nftMarketplace-card__paramsValue' + (item.id === 'breeding' ? ' nftMarketplace-card__paramsValue_briding-' + (item.value ? 'y' : 'n') : '')}>
                                            {item.id === 'breeding' ? (item.value ? 'Yes' : 'No') : item.value}
                                            </div>
                                    </div>
                                })}
                            </div>
                        </div> : ''
                }

                {
                    nftData?.sellerComment ?
                        <div className='nftMarketplace-card__sellerCommentBlock'>
                            <span className="nftMarketplace-card__sellerCommentCaption">Seller's comment:</span>
                            <span className="nftMarketplace-card__sellerCommentText">{nftData?.sellerComment}</span>
                        </div> : ''
                }

                {
                    characteristics.length ?
                        characteristics.map((item) => {
                            return <div key={item.id}>{item.title}: {item.value}</div>
                        }) : ''
                }
                
                {/* <div className='nftMarketplace-card__line'></div> */}
                <SizedBox height={10}/>
                {
                    nftData?.seller ? <Tabs align='left' tabs={tabs} /> : ''
                }
                <div className='nftMarketplace-card__tabContent'>
                    {
                        nftData ?
                            activeTab === TABS.PRICE ?
                                <PriceBlock nftData={nftData} cb={() => {setVersion(version + 1)}} /> :
                                nftData.seller ? <Auction nftData={nftData} preloadData={preloadBids} bidsCountChaned={setBidsCount}/> : ''
                            : ''
                    }
                </div>
            </div>
        </div>
    );
});
